import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';

import * as authActions from '@app/modules/authentication/actions/authentication.actions';

import { NotificationsService } from '../services/notifications.service';
import { map } from 'rxjs/operators';

@Injectable()
export class NotificationsEffects {
  @Effect({dispatch: false}) loginFailed$ = this.actions$.pipe(
    ofType(authActions.loginFailed),
    map((data: any) => this.notificationService.error(
      this.translateService.instant('general.actions.error'),
      this.translateService.instant('general.notifications.authentication.loginFailed.' + data?.error?.error?.message?.split('.').pop())
    ))
  );

  @Effect({dispatch: false}) logoutFailed$ = this.actions$.pipe(
    ofType(authActions.logoutFailed),
    map(() => this.notificationService.error(
      this.translateService.instant('general.actions.error'),
      this.translateService.instant('general.notifications.authentication.logoutFailed')
    ))
  );

  constructor(
    private notificationService: NotificationsService,
    private translateService: TranslateService,
    private actions$: Actions,
  ) {
  }
}
